export class Video {
    constructor(selector) {
        this.selector = selector
    }

    load() {
        const button_load = this.selector.querySelector('.video .button')
        const video_url = this.selector.dataset.url
        const video_disclaimer = this.selector.querySelector('.video-disclaimer')
        const video_width = this.selector.dataset.width ? this.selector.dataset.width : 640
        const video_height = this.selector.dataset.height ? this.selector.dataset.height : 360

        if (video_url) {
            const video_iframe = `<iframe width="${video_width}" height="${video_height}" src="${video_url}"
                allowfullscreen></iframe>`

            button_load.addEventListener('click', () => {
                video_disclaimer.insertAdjacentHTML('beforebegin', video_iframe)
                video_disclaimer.remove()
            })
        }
    }
}
